import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function FaqTab({data}) {
  console.log("FAQ data in FaqTab:", data.faqs) // Log the FAQs data to verify it's being passed correctly;

  return (
    <div>
      <Typography variant="h6" mb={1}>Frequently Asked Questions</Typography>

      {data.faqs?.map((faq, idx) => (
        <Accordion key={idx}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography fontSize={14} color="text.secondary">
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
